import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutModule as CdkLayoutModule } from '@angular/cdk/layout';
import { MaterialModule } from '../material.module';
import { DocLayoutComponent } from './doc-layout/doc-layout.component';
import { MenuItemComponent } from '../content/pages/menu-item/menu-item.component';

@NgModule({
  declarations: [DocLayoutComponent, MenuItemComponent],
  imports: [CommonModule, RouterModule, MaterialModule, CdkLayoutModule],
  exports: [DocLayoutComponent],
})
export class LayoutModule {}
